import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, message, Modal, Popconfirm } from 'antd';
import { Route, Switch } from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import View from './view';
import {
  createResource, createResourceWithExcel,
  deleteResource,
  fetchResource,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  updateResource
} from "../../appRedux/actions/SaleOrder";
import {
  fetchAssetsByLocation,
  fetchEquipmentSubType,
  fetchFilter, fetchLeasableAssetData,
  fetchSubDocumentFilter,
  fetchSubElementFilter,
  unmountSaleOrder
} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import * as _ from 'lodash';

export class SaleOrder extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
    this.props.fetchSubDocumentFilter('Document');
    this.props.fetchSubElementFilter('Asset');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({ visibleColumns: columns }, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const { filters } = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = { ...this.props.query };
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    // this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = { ...this.props.query };
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = { ...this.props.query };
    query.pagination = { ...query.pagination, current: pagination.current };
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;

    Object.keys(filters).forEach((item) => {

      if (item === '_id') {
        return;
      }

      if (selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: item === 'soNo' ? 'SI No' : sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>
          {/* <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>Edit</Button>
          }}/> */}

          <AccessControl resource={this.props.resourceName} permissionNeeded={'r'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Button type="primary" style={{ marginLeft: '10px' }} size='small' onClick={() => this.view(record._id)}>View</Button>
            }} />

          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
            roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
              return <Button style={{ marginLeft: '10px' }} type="danger" size='small' onClick={() => {
                Modal.confirm({
                  title: 'Are you sure you want to delete this record?',
                  content: 'All Assets along with dependent assets in this Sale Order will be back to original location and sub location',
                  okText: 'Yes',
                  okType: 'danger',
                  cancelText: 'No',
                  onOk: () => {
                    this.deleteResource(record._id)
                  },
                  onCancel: this.cancelDelete
                })
              }}>Delete</Button>
              // return <Popconfirm
              //   title="Are you sure you want to delete this record?"
              //   description="All Assets along with dependent assets in this Sale Order will be back to original location and sub location"
              //   onConfirm={() => {
              //     this.deleteResource(record._id)
              //   }}
              //   onCancel={this.cancelDelete}
              //   okText="Yes"
              //   cancelText="No"
              // >
              //   <Button style={{ marginLeft: '10px' }} type="danger" size='small'>Delete</Button>
              // </Popconfirm>
            }} />

        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values) => {
    this.props.createResource(values);
  };

  updateResource = (values, id) => {
    values.documents = values.documents || [];
    this.props.updateResource(values, id);
  };

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  view = (id) => {
    const { match } = this.props;
    this.props.history.push(`${match.url}/view/${id}`);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "SalesInvoice");
  }

  componentWillUnmount() {
    this.props.unmountSaleOrder();
  }

  assetSearch = (value, model = 'Asset', field = 'assetCode') => {
    if (value && value.length >= 2)
      this.props.fetchLeasableAssetData(value, model, field);
  };

  render() {
    const { match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName, assetsList, fetchEquipmentSubType, equipmentData } = this.props;
    const { columns, visibleColumns } = this.state;
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>{sanitizeFieldName('salesInvoice')}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
          render={() => <List columns={columns}
            visibleColumn={visibleColumns}
            data={data}
            clearFilter={this.clearAll}
            filters={filters}
            handleChange={this.handleChange}
            columnChange={this.handleColumnChange}
            downloadToCSV={this.downloadToCSV}
            title={resourceName}
            size={'middle'}
            create={this.create}
            pagination={this.props.query.pagination}
            loading={loading}
            authUser={authUser}
          />
          } />
        <Route path={`${match.url}/add`}
          render={(props) => <Create data={{}}
            filters={filters}
            modules={modules}
            fetchEquipmentSubType={fetchEquipmentSubType}
            equipmentData={equipmentData}
            title={'CREATE'}
            resource={resourceName}
            onChange={this.handleFormChange}
            onSubmit={this.createResource}
            loading={loading}
            assetsList={assetsList}
            fetchAssetsByLocation={this.props.fetchAssetsByLocation}
            assetSearch={this.assetSearch}
            assetData={this.props.assetData}
            createResourceWithExcel={this.props.createResourceWithExcel}
            {...props}
          />
          } />
        <Route path={`${match.url}/edit/:id`}
          render={(props) => <Create data={edit}
            filters={filters}
            modules={modules}
            fetchEquipmentSubType={fetchEquipmentSubType}
            equipmentData={equipmentData}
            title={'EDIT'}
            resource={resourceName}
            fetch={fetchResource}
            onChange={this.handleFormChange}
            onSubmit={null}
            loading={loading}
            assetsList={assetsList}
            fetchAssetsByLocation={this.props.fetchAssetsByLocation}
            assetSearch={this.assetSearch}
            assetData={this.props.assetData}
            createResourceWithExcel={this.props.createResourceWithExcel}
            {...props}
          />
          } />

        <Route path={`${match.url}/view/:id`}
          render={(props) => <View
            data={edit}
            filters={filters}
            modules={modules}
            fetchEquipmentSubType={fetchEquipmentSubType}
            equipmentData={equipmentData}
            title={'VIEW'}
            resource={resourceName}
            fetch={fetchResource}
            viewEarlier={this.view}
            onChange={this.handleFormChange}
            onSubmit={null}
            loading={loading}
            assetsList={assetsList}
            fetchAssetsByLocation={this.props.fetchAssetsByLocation}
            {...props}
          />
          } />
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({ auth, saleOrder, commonData }) => {
  return {
    authUser: auth.authUser,
    total: saleOrder.total,
    data: saleOrder.resources,
    resource: saleOrder.resource,
    edit: saleOrder.edit,
    query: saleOrder.query,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    subDocumentFilters: commonData.subDocumentFilters,
    subAssetFilters: commonData.subElementFilters,
    assetsList: saleOrder.assetsList,
    equipmentData: saleOrder.equipmentData,
    assetData: commonData.relationshipSearch,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    fetchSubDocumentFilter,
    fetchSubElementFilter,
    fetchAssetsByLocation,
    fetchEquipmentSubType,
    unmountSaleOrder,
    fetchLeasableAssetData,
    createResourceWithExcel
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(SaleOrder);
